const headerBurger = document.querySelector('.headerV3__nav-burger')

if (headerBurger) {
    headerBurger.addEventListener('click', (evt) => {        
        const open = headerBurger.querySelector('.headerV3__nav-menu')
        const close = headerBurger.querySelector('.header__burger-close')
        const header = document.querySelector('.headerV3')
        const headerNav = document.querySelector('.headerV3__nav')
        const menuList = document.querySelector('.headerV3__mobile-menu') 

        if (evt.target === open) {            
            headerNav.classList.add('header__nav_open')
            open.classList.add('header__burger-menu_disable')
            close.classList.add('header__burger-close_enable')
            header.classList.add('header_mobile')
            menuList.classList.add('active__menu')
        } else if (evt.target === close) {
            headerNav.classList.remove('header__nav_open')
            open.classList.remove('header__burger-menu_disable')
            close.classList.remove('header__burger-close_enable')
            header.classList.remove('header_mobile')
            menuList.classList.remove('active__menu')
        }
    })
}